import FinancialServicesApi from '../../../core/api/FinancialServicesApi'
export const VALIDATE_FINDANIFA = 'VALIDATE_FINDANIFA'
export const FETCHING_FINANCIALSERVICES = 'FETCHING_FINANCIALSERVICES'
export const FETCH_FINANCIALSERVICES = 'FETCH_FINANCIALSERVICES'

export const validateState = (specificComponent) => ({
  type: VALIDATE_FINDANIFA,
  specificComponent
})

export const fetchingFinancialServices = () => ({
  type: FETCHING_FINANCIALSERVICES
})

export function fetchFinancialServices () {
  const api = new FinancialServicesApi()
  
  return async (dispatch) => {
    try{
      const response = await api.fetchingFinancialServices()
      dispatch({
        type: FETCH_FINANCIALSERVICES,
        payload: response
      })
      return response
    } catch(error){
      dispatch({
        type: FETCH_FINANCIALSERVICES,
        payload: []
      })
      throw error
    }
  }
}

